import { css } from '@emotion/react';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import t from 'react-translate';
import MentoringProgramContext from 'athena/components/mentoring-program/context';
import { getMentoringProgramAliases } from 'redux/selectors/mentoring-programs';
import { CellProps } from './types';


const styles = css`
  .add-individual-target {
    opacity: 0;
    flex-shrink: 0;
  }
`;

const AddButtonCell = (props: CellProps) => {
  const { className } = props;
  const value = props.cell.getValue();

  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { id: programId } = mentoringProgram || {};
  const mentoringProgramAliases = useSelector((state) => getMentoringProgramAliases(state, programId));

  const handleAddAsMentor = () => {};

  return (
    <div css={styles} className={className}>
      <Button
        variant='outline-primary'
        className='add-individual-target'
        onClick={handleAddAsMentor}
      >
        {t.MENTORING_PROGRAMS.RECRUITMENT.ADD_AS_MENTOR(mentoringProgramAliases)}
      </Button>
    </div>
  );
};

export default AddButtonCell;
